import React from "react";
import { Field, FieldProps } from "formik";
import { FormCheck } from "react-bootstrap";

type OptionValue = number | string;

export interface MultiSwitchOption {
    value: OptionValue;
    label: React.ReactNode;
}

interface MultiSwitchFieldProps {
    name: string;
    options: MultiSwitchOption[];
    disabled?: boolean;
    switchWrapperClassName?: string;
}

export const MultiSwitchField: React.FC<MultiSwitchFieldProps> = ({
    name,
    options,
    disabled = false,
    switchWrapperClassName = "form-check form-switch ps-3 mb-0 d-flex align-items-center",
}) => {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps<OptionValue[]>) => {
                const selected: OptionValue[] = Array.isArray(field.value) ? field.value : [];

                const toggle = (value: OptionValue) => {
                    const nextValue = selected.includes(value)
                        ? selected.filter((v) => v !== value)
                        : [...selected, value];

                    form.setFieldValue(field.name, nextValue);
                };

                return (
                    <>
                        {options.map((option) => (
                            <div key={String(option.value)} className={switchWrapperClassName}>
                                <FormCheck
                                    type="checkbox"
                                    id={`${name}-${option.value}`}
                                    className="fs-7 text-primary-grey mb-0 py-1"
                                    label={option.label}
                                    checked={selected.includes(option.value)}
                                    onChange={() => toggle(option.value)}
                                    disabled={disabled}
                                />
                            </div>
                        ))}
                    </>
                );
            }}
        </Field>
    );
};

export default MultiSwitchField;
